var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5399 50.0101L71.0099 59.0601L61.0899 64.1801L57.8099 60.3601L49.6799 59.1101L47.5299 69.7201L39.4199 77.4801L47.6299 83.3201L51.7799 80.1101L56.8499 91.1901L77.0899 90.5101L85.4599 98.0001L91.6999 92.3801L89.8499 85.2001L96.8299 81.5201L94.3599 64.3401L97.9999 58.7701L90.7599 46.8201L77.5399 50.0101Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98004 6.01L20.56 10.55L29.87 3.87L42.86 2L46.39 5.87L43.09 9.32L45.7 16.31L36.1 19.95L36.3 29.93L27.11 34L25.01 44.85L14.9 45.77L2 29.89L5.10004 19.61L2 13.89L8.98004 6.01Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0698 20.53C17.0698 20.53 16.9698 20.98 16.7998 21.78",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2698 27.65C18.1642 27.65 19.6998 26.1144 19.6998 24.22C19.6998 22.3257 18.1642 20.79 16.2698 20.79C14.3755 20.79 12.8398 22.3257 12.8398 24.22C12.8398 26.1144 14.3755 27.65 16.2698 27.65Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8704 76.9801C82.7648 76.9801 84.3005 75.4445 84.3005 73.5501C84.3005 71.6558 82.7648 70.1201 80.8704 70.1201C78.9761 70.1201 77.4404 71.6558 77.4404 73.5501C77.4404 75.4445 78.9761 76.9801 80.8704 76.9801Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9896 72.56C27.884 72.56 29.4196 71.0243 29.4196 69.13C29.4196 67.2356 27.884 65.7 25.9896 65.7C24.0953 65.7 22.5596 67.2356 22.5596 69.13C22.5596 71.0243 24.0953 72.56 25.9896 72.56Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1104 40.28H75.1904V18.2L53.1104 18.2V40.28Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3505 25.71H66.9404V18.21H61.3505V25.71Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2003 35.05H64.8203",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3604 30.44C15.4704 29.59 15.5903 28.77 15.7003 28",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8203 35.3499C14.8903 34.5099 14.9803 33.6899 15.0603 32.8999",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5098 40.2701C14.5398 39.4401 14.5898 38.6201 14.6398 37.8101",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4599 45.2C14.4399 44.38 14.4399 43.55 14.4499 42.73",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7496 50.1299C14.6696 49.3199 14.5996 48.4999 14.5596 47.6699",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4996 55.0001C15.3296 54.2101 15.1896 53.3901 15.0596 52.5701",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8796 59.7299C16.5896 58.9799 16.3296 58.1999 16.0996 57.3899",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1697 64.09C18.6997 63.43 18.2696 62.73 17.8896 61.98",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6598 67.54C21.9798 67.08 21.3398 66.55 20.7598 65.97",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1795 69.5C31.3795 69.68 30.5495 69.76 29.6895 69.75",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.69 67.3799C36 67.8899 35.29 68.3199 34.54 68.6799",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2996 63.9099C39.7496 64.5699 39.1796 65.1899 38.5996 65.7599",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2498 59.8501C42.7898 60.5601 42.3198 61.2601 41.8398 61.9201",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8501 55.55C45.4301 56.28 45.0101 57 44.5801 57.71",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3298 51.1899C47.9198 51.9199 47.5098 52.6499 47.0898 53.3799",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8801 46.8601C50.4401 47.5601 50.0101 48.2801 49.5801 49.0101",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53.73 42.73C53.23 43.37 52.73 44.05 52.25 44.76",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1401 45.2099C75.8101 44.4099 75.4601 43.6399 75.0801 42.8899",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8 50.0201C77.56 49.2001 77.31 48.3901 77.04 47.5901",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9995 54.97C78.8295 54.14 78.6395 53.31 78.4395 52.48",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8804 59.98C79.7604 59.15 79.6305 58.31 79.4805 57.46",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4897 65.04C80.4097 64.22 80.3197 63.37 80.2197 62.51",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8702 70.1201C80.8302 69.3201 80.7702 68.4701 80.7002 67.5801",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/tracking.75db4d92cfb1a658c7425ff78e55eebe.svg";
export { ForwardRef as ReactComponent };